// Utils for 'List' service actions - subset of service/run actions connected to account-level lists
import type { Action, ActionOption } from 'flow/store/engine/types';
import { filterActionsByType, isActionOfType } from '..';
import { LIST_SERVICE_KEY_IN_SERVICES } from 'flow/service/services/constants';
import { ActionType } from 'flow/store/engine/constants';

export function isListAction(action: Action): boolean {
  return isActionOfType(action, ActionType.SERVICE)
      && action.service.internalName === LIST_SERVICE_KEY_IN_SERVICES;
}

export function getListId(action: Action): ActionOption['value'] {
  if (!isListAction(action)) return null;
  const { value } = action.options.customer_list_id;
  return value;
}

export function getListActionsByListName(
  actions: Record<string, Action>,
  listName: string): Action[] {
  const listActions = filterActionsByType(actions, ActionType.SERVICE)
    .filter(action => isListAction(action) && action.service.name === listName);
  return listActions;
}
